import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EarIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>((props, forwardedRef) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M7.76 19.85C7.56 19.94 7.29 20 7 20C5.9 20 5 19.1 5 18H3C3 20.21 4.79 22 7 22C7.57 22 8.13 21.88 8.64 21.65C10 20.94 10.77 19.92 11.37 18.1C11.69 17.12 12.27 16.67 13.08 16.05C13.95 15.38 15.02 14.55 15.93 12.9C16.62 11.65 17 10.26 17 8.99997C17 5.06997 13.93 1.99997 10 1.99997C6.07 1.99997 3 5.06997 3 8.99997H5C5 6.19997 7.2 3.99997 10 3.99997C12.8 3.99997 15 6.19997 15 8.99997C15 9.92997 14.71 10.98 14.18 11.94C13.473 13.2245 12.6569 13.8546 11.87 14.4622L11.8348 14.4895C10.9225 15.1934 9.97534 15.9242 9.47 17.47C8.97 18.97 8.47 19.48 7.76 19.85Z"
          fill="#222"
        />
        <path
          d="M17.78 1.21997L16.36 2.63997C17.99 4.25997 19 6.50997 19 8.99997C19 11.49 17.99 13.74 16.37 15.37L17.78 16.78C19.77 14.79 21 12.04 21 8.99997C21 5.95997 19.77 3.20997 17.78 1.21997Z"
          fill="#222"
        />
        <path
          d="M12.5 8.99997C12.5 7.61997 11.38 6.49997 10 6.49997C8.62 6.49997 7.5 7.61997 7.5 8.99997C7.5 9.78036 7.85816 10.4776 8.41897 10.9362C8.03967 11.4025 7.63035 11.9119 7.25457 12.4164C6.82667 12.991 6.41327 13.5974 6.13222 14.1575C5.99169 14.4375 5.86656 14.7403 5.79724 15.0461C5.72992 15.343 5.69472 15.7324 5.8395 16.125C6.03059 16.6432 6.60556 16.9083 7.12373 16.7172C7.61474 16.5362 7.87856 16.0104 7.7423 15.5149C7.7428 15.5121 7.74336 15.5091 7.744 15.5059C7.74504 15.5006 7.74627 15.4948 7.74774 15.4883C7.76819 15.3981 7.81909 15.2551 7.91978 15.0545C8.12118 14.6531 8.45099 14.1584 8.85861 13.611C9.2614 13.0702 9.71201 12.515 10.139 11.9914C10.9898 10.9484 12.5 10.5732 12.5 8.99997ZM7.73881 15.5399L7.73864 15.5437L7.73866 15.542L7.73881 15.5399Z"
          fill="#222"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </IconWrapper>
  )
})
